import { Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit } from '@angular/core';
import { ModalComponent } from '../ModalComponent/modal.component';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { timeoutConfig } from './timeoutConfig';

@Component({
  selector: 'session-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  providers: [ CookieService ]
})

export class TimeoutComponent implements OnInit, AfterViewInit  {
  @ViewChild(ModalComponent) modal: ModalComponent;
  
  @Input() userConfig: any;

  defaultConfig: any = timeoutConfig;
  props: any;
  dialogTimer: any;
  sessionTimer: any;
  countdownInterval: any;
  cookieDomain: string;

  constructor(private cookieService: CookieService, private elRef:ElementRef, private http: HttpClient) { 

    this.cookieDomain = '';

    var myLocation = window.location.hostname.toLowerCase(),
        checkLocalEnv = (myLocation === 'localhost') || (myLocation === 'edgnydev1.prudential.com');

    this.cookieDomain = checkLocalEnv ? '' : ';domain=.prudential.com;path=/';
  }

  ngOnInit() {
    var me = this;

    if (this.userConfig) {
      this.props = Object.assign(this.defaultConfig, this.userConfig);
    } else {
      this.props = this.defaultConfig;
    }
    

    this.checkVisitedSystems();

    if (sessionStorage.currentDdo) {
      let ddo = JSON.parse(sessionStorage.currentDdo);
      if (ddo && ddo.user.profile.profileInfo && /csr/i.test(ddo.user.profile.profileInfo.userType)) {
        this.props.warnAfter = 28800000;
        this.props.redirAfter = 28860000;
      }
    }

    if (!this.props.warnOnly && this.props.warnAfter >= this.props.redirAfter) {
      console.error('Option "redirAfter" must be equal or greater than "warnAfter".');
      return false;
    }



    /*intercept ajax calls*/
    (function () {
      const proxied = (window as any).XMLHttpRequest.prototype.open;
      (window as any).XMLHttpRequest.prototype.open = function () {
        const regex = new RegExp('^\\s*(?:[a-z0-9]+:)?//', 'i');
        const isRelativePath = !regex.exec(arguments[1]);
        //console.log('xml_interecept', arguments[1], isRelativePath);
        // reset time if xhr request is from *.prudential.com
        if (isRelativePath) {
          me.setPruTimerCookie(new Date().getTime() + me.props.warnAfter);
          me.startSessionTimer(true);
        }

        return proxied.apply(this, [].slice.call(arguments));
      };
    })();

  }

  ngAfterViewInit() {
    this.setPruTimerCookie((new Date()).getTime() + this.props.warnAfter);
   this.startSessionTimer(false);
  }

  checkVisitedSystems() {
    let host = window.location.origin.toLowerCase(),
        onePixUrl = host + '/ucd/images/onepix.jpg',
        currentEnv = 'prod';

        if (/dev/i.test(host)) {
          currentEnv = 'dev';
        }
        if (/qa/i.test(host)) {
          currentEnv = 'qa';
        }
        if (/uat/i.test(host)) {
          currentEnv = 'uat';
        }
        if (/stage/i.test(host)) {
          currentEnv = 'stage';
        }

        var domainEnv = (currentEnv === 'prod') ? '' : '-' + currentEnv;
        var visitedSystems = this.cookieService.get('VisitedSystems');

        if (/pol/i.test(visitedSystems)) {
          this.props.keepAliveUrl.push('https://client' + domainEnv + '.prudential.com/images/x.gif');
        }
        
        if (/RET_PPT/i.test(visitedSystems)) {
          if(/prod/i.test(domainEnv)){
            this.props.keepAliveUrl.push('https://www.retirement.prudential.com/TRSWeb/b2c.html');
          }else{
            this.props.keepAliveUrl.push('https://retirement' + domainEnv + '.prudential.com/TRSWeb/b2c.html');
          }
          

          if (domainEnv === 'stage') {
            this.props.keepAliveUrl.push('https://retirement-aggregator-stage.prudential.com/TRSWeb/b2c.html');
          }
        }

        if (host !== 'localhost') {
          let myLogoutUrl = this.cookieService.get('MYACCTLOGOUT');
          this.props.logoutUrl = myLogoutUrl? myLogoutUrl:'/ucd/logout/logout.html';
        }

        this.props.keepAliveUrl.push(onePixUrl);
  }

  onStayConnected() {
    this.modal.hide();
    let dialogPruTimer = this.readCookie('prutimer');

    if (dialogPruTimer) {
      this.setPruTimerCookie((new Date()).getTime() + this.props.warnAfter);
      this.startSessionTimer(false);
    } else {
      window.location.href = this.props.logoutUrl;
    }
  }

  setPruTimerCookie(cookieValue) {
    document.cookie = 'prutimer=' + cookieValue + ';path=/' + this.cookieDomain;
  }

  readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        var cvalue = c.substring(nameEQ.length, c.length);
        if (cvalue) {
          return parseInt(cvalue)
        } else {
          return ''
        }
      }
    }
    return '';
  }

  startSessionTimer(byPassKeepAlive?: any, resetSession?: any) {
    resetSession = resetSession ? resetSession : this.props.warnAfter;

    var me = this;

    clearTimeout(this.sessionTimer);
    clearTimeout(this.dialogTimer);
    clearInterval(this.countdownInterval);

    if (this.props.countdownBar) {
      this.props.countdownWidth = 100;
      this.props.countdownText = '';
    }

    if (!byPassKeepAlive && this.props.keepAliveVal) {
      this.keepAlive();
    }

    this.sessionTimer = setTimeout(function() {

      if (typeof me.props.onWarn !== 'function') {
        var sessionPruTimer: any = me.readCookie('prutimer');

        if (sessionPruTimer) {
          var sessionNow = new Date().getTime();

          if (sessionNow >= sessionPruTimer) {
            me.modal.show();
            me.startDialogTimer(resetSession);
          } else {
            me.startSessionTimer(false, (sessionPruTimer - sessionNow)); //modified from true to false
          }
        } else {
          window.location.href = me.props.logoutUrl;
        }

        } else {
          me.props.onWarn(me);
        }
      }, resetSession);
  }

  startDialogTimer(resetSession: any) {
    var me = this;

    clearTimeout(this.dialogTimer);
    
    if (this.elRef.nativeElement.querySelector('pru-modal').classList.contains('in') && ( this.props.countdownMessage ||  this.props.countdownBar)) {

      this.startCountdownTimer('dialog', resetSession);
    }

    var dialogTimerCnt = resetSession <= 0 ? resetSession +  this.props.redirAfter -  this.props.warnAfter :  this.props.redirAfter -  this.props.warnAfter

    this.dialogTimer = setTimeout(function() {

      var dialogPruTimer: any = me.readCookie('prutimer');

      if (dialogPruTimer) {
        var dialogNow = new Date().getTime();
        if (dialogNow >= (dialogPruTimer +  me.props.redirAfter -  me.props.warnAfter)) {

          if (typeof me.props.onRedir !== 'function') {
            if ( me.props.refreshOnTimeOut) {
              me.modal.hide();
              window.location.reload(true);
            } else {
               me.props.redirUrl =  me.props.redirUrl ?  me.props.redirUrl :  me.props.logoutUrl;
              me.expirePruTimerCookie();
              window.location.href =  me.props.redirUrl;
            }

          } else {
             me.props.onRedir(me);
          }
        } else {
          me.modal.hide();
          // me.startSessionTimer(true, dialogPruTimer - dialogNow);
        }
      } else {
        window.location.href =  me.props.logoutUrl;
      }

    }, dialogTimerCnt);
  }

  startCountdownTimer(type, resetSession) {
    var me = this;

    clearInterval(this.countdownInterval);

    if (type === 'dialog') {
      if (resetSession && resetSession <= 0) {
        this.props.countdown.timeLeft = Math.floor((resetSession +  this.props.redirAfter -  this.props.warnAfter) / 1000);
      } else { this.props.countdown.timeLeft = Math.floor(( this.props.redirAfter -  this.props.warnAfter) / 1000); }
    } else if (type === 'session') {
      this.props.countdown.timeLeft = Math.floor( this.props.redirAfter / 1000);
    }

    var countdownEl = this.elRef.nativeElement.querySelector('#countdownHolder');

    this.countdownInterval = setInterval(function() {

      if ( me.props.countdownBar && type === 'dialog') {
        me.props.countdown.percentLeft = Math.floor(me.props.countdown.timeLeft / (( me.props.redirAfter -  me.props.warnAfter) / 1000) * 100);
      } else if ( me.props.countdownBar && type === 'session') {
        me.props.countdown.percentLeft = Math.floor(me.props.countdown.timeLeft / ( me.props.redirAfter / 1000) * 100);
      }

      var secondsLeft = me.props.countdown.timeLeft >= 0 ? me.props.countdown.timeLeft : 0;

      if ( me.props.countdownSmart) {
        var minLeft = Math.floor(secondsLeft / 60),
          secRemain = secondsLeft % 60,
          countTxt = minLeft > 0 ? minLeft + 'm ' : '';
        countTxt += secRemain + 's';
        countdownEl.textContent = countTxt;
      } else {
        countdownEl.textContent = secondsLeft + 's';
      }

      if ( me.props.countdownBar ) {
        me.elRef.nativeElement.querySelector('#countdownBar').style.width = me.props.countdown.percentLeft + '%';
      }

      me.props.countdown.timeLeft = me.props.countdown.timeLeft - 1;
    }, 1000);

  }

  onSessionLogout() {
    if (!this.props.logoutFunction) {
      this.expirePruTimerCookie();
      window.location.href = this.props.logoutUrl;
    } else {
      this.props.logoutFunction();
    }
  }

  expirePruTimerCookie() {
    document.cookie = 'prutimer=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/' + this.cookieDomain;
  }

  keepAlive() {
    var me = this;

    if (!this.props.keepAlivePinged && this.props.keepAliveUrl) {
      for (var i = 0; i < this.props.keepAliveUrl.length; i++) {
        this.http.get(this.props.keepAliveUrl[i], this.props.ajaxData)
        .subscribe(res=>{
          console.log('session extended ', res);
        }
        // ,(error)=>{
        //   console.log('error', error);
        //   this.onSessionLogout();
        // }
        )
      }

      this.props.keepAlivePinged = true;
      setTimeout(function() {
        me.props.keepAlivePinged = false;
      }, this.props.keepAliveInterval);
    }
  }

  restartTimer() {
    this.modal.hide();
    this.startSessionTimer(false);
  }



}